<template>
  <el-cascader
    :value="value"
    :options="options"
    :props="{
      checkStrictly: checkStrictly || false,
      value: 'area_id',
      label: 'area_name',
      children: 'child',
      emitPath: emitPath,
    }"
    clearable
    :placeholder="placeholder"
    @clear="$emit('clear')"
    @change="changeValue"
  ></el-cascader>
</template>

<script>
import { getAreaLists } from "@/api/common.js";
export default {
  props: ["value", "placeholder", "checkStrictly", "emitPath"],
  data() {
    return {
      options: [],
    };
  },
  // model:{

  // }
  mounted() {
    this.getArea();
  },
  methods: {
    changeValue(val) {
      if (val instanceof Array) {
        this.$emit("input", val[val.length - 1]);
        this.$emit("province_id", val[0]);
        this.$emit("area_id", val[1]);
        this.$emit("city_id", val[2]);
      } else {
        this.$emit("input", val);
      }
    },
    getArea() {
      getAreaLists().then((res) => {
        console.log(res);
        if (res instanceof Array) {
          this.options = res;
        }
      });
    },
  },
};
</script>

<style></style>
